import { useEffect, useState, useMemo, useRef } from "react";
import styles from "./index.module.less";
import {
  Iconsvg,
  InputField,
  ButtonField,
  SelectField,
  TextareaField,
} from "@wk/components-react16";
import { useNavigate, useLocation } from "react-router-dom";
import ModalConfirm from "../player/modal";
import { useUser } from "@/utils/UserContext";

import {
  getPlayerDetail,
  getCode,
  verifySmsCode,
  editUser,
} from "@/services/user";
import { cloneDeep } from "lodash-es";
const phoneRegex = /^1[3-9]\d{9}$/;

const Activation = () => {
  const { set } = useUser();

  const [isSuccess, setIsSuccess] = useState(false);
  const [isNotRegistered, setIsNotRegistered] = useState(false);
  const [userInfo, setUserInfo] = useState();
  const [phone, setPhone] = useState("");

  const [number, setNumber] = useState(6);

  const [second, setSecond] = useState(0);
  const [isVerifyError, setIsVerifyError] = useState(false);
  const [isCodeOpen, setIsCodeOpen] = useState(false);
  const [isVerifyLoading, setIsVerifyLoading] = useState(false);

  const [firstCode, setFirstCode] = useState("");
  const [secondCode, setSecondCode] = useState("");
  const [thirdCode, setThirdCode] = useState("");
  const [forthCode, setForthCode] = useState("");

  const codeNumFirstRef = useRef(null);
  const codeNumSecondRef = useRef(null);
  const codeNumThirdRef = useRef(null);
  const codeNumForthRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [messageText, setMessageText] = useState("");

  const getPhoneInfo = async () => {
    const queryParams = new URLSearchParams(location.search);
    const phoneNumber = queryParams.get("phone"); // 获取查询参数 id
    setPhone(phoneNumber);

    if (
      !phoneNumber ||
      phoneNumber.length !== 11 ||
      !phoneRegex.test(phoneNumber)
    ) {
      return;
    }
    const res = await getPlayerDetail(phoneNumber);
    if (res.code === 200) {
      if (!res?.result?.current) {
        setIsNotRegistered(true);
        return;
      }

      if (res?.result?.current) {
        setIsCodeOpen(true);
      }
    }
  };

  const goUserDetail = (user) => {
    let time = 6;
    setNumber(--time);
    let clearTimer = setInterval(() => {
      setNumber(--time);
      if (time < 1) {
        clearInterval(clearTimer);
        set(user);
        navigate("/player");
      }
    }, 1000);
  };

  const delText = useMemo(() => {
    if (!phone) {
      return "";
    }
    return `${phone.slice(0, 3)}****${phone.slice(phone.length - 4)}`;
  }, [phone]);

  const getSecondCode = async () => {
    const res = await getCode(phone);
    // 开始倒计时
    let time = 60;
    setSecond(--time);
    let clearTimer = setInterval(() => {
      setSecond(--time);
      if (time < 1) {
        clearInterval(clearTimer);
      }
    }, 1000);
    if (res?.code === 200) {
      setIsCodeOpen(true);
      setTimeout(() => {
        codeNumFirstRef.current.focus();
      }, 1000);
    } else if (res?.code === 500) {
      setMessageText("短信验证码发送失败，请稍后重试");
      setIsMessageOpen(true);
    }
  };

  const activation = async () => {
    const res = await getPlayerDetail(phone);
    if (!res?.result?.current) {
      setIsNotRegistered(true);
      return;
    }

    if (res?.result?.current && res?.result?.current.status === "1") {
      setUserInfo(res.result.current);
      setIsSuccess(true);
      goUserDetail(res.result.current);
      return;
    }

    if (res?.result?.current && res?.result?.current.status === "2") {
      const value = cloneDeep(res.result.current);
      const editRes = await editUser({ ...value, status: "1" });
      if (editRes?.code === 200) {
        setUserInfo({ ...value, status: "1" });
        setIsSuccess(true);
        goUserDetail({ ...value, status: "1" });
      }
    }
  };

  const verifyCode = async (
    valueFirst,
    valueSecond,
    valueThird,
    valueForth
  ) => {
    if (!valueFirst || !valueSecond || !valueThird || !valueForth) {
      return;
    }

    setIsVerifyLoading(true);
    try {
      const res = await verifySmsCode(
        `${valueFirst}${valueSecond}${valueThird}${valueForth}`,
        phone
      );
      if (res.code === 200) {
        await activation();
        setIsCodeOpen(false);
        setFirstCode("");
        setSecondCode("");
        setThirdCode("");
        setForthCode("");
      }

      if (res?.code === 500) {
        setIsVerifyError(true);
      }
    } catch (error) {
      setIsVerifyLoading(false);
    }
    setIsVerifyLoading(false);
  };

  useEffect(() => {
    verifyCode(firstCode, secondCode, thirdCode, forthCode);
  }, [firstCode, secondCode, thirdCode, forthCode]);

  useEffect(() => {
    getPhoneInfo();
  }, []);

  return (
    <div className={styles["activation-box"]}>
      {isSuccess && (
        <>
          <img
            src="https://cdn.wolterskluwer.io/wk/jumpstart-v3-assets/0.x.x/icons/illustrated/light/large/no-favorites.svg"
            alt="No favorites - large"
          />
          <div className="text">激活成功</div>
          <div className="text2">{number}秒后自动跳转至个人资料信息页</div>
          <div className="btn-box">
            <ButtonField>
              <button
                type="button"
                onClick={() => {
                  set(userInfo);
                  navigate("/player");
                }}
              >
                进入个人资料信息
              </button>
            </ButtonField>

            <ButtonField mode={"ghost"}>
              <button
                type="button"
                onClick={() => {
                  set(userInfo);
                  navigate("/");
                }}
              >
                进入首页
              </button>
            </ButtonField>
          </div>
        </>
      )}

      <ModalConfirm
        isOpen={isNotRegistered}
        onClose={() => {
          setIsNotRegistered(false);
        }}
        children={
          <div className="modal-body-text">账号未注册，是否跳转到注册页</div>
        }
        title={"操作确认"}
        onConfirm={() => {
          navigate("/register");
        }}
        okText="确认"
        cancelText="取消"
      />

      <ModalConfirm
        height="368px"
        isOpen={isCodeOpen}
        onClose={() => {
          setIsCodeOpen(false);
          setFirstCode("");
          setSecondCode("");
          setThirdCode("");
          setForthCode("");
          setIsVerifyError(false);
        }}
        children={
          <div className="modal-body-box">
            <div className="code-box">
              <div className="modal-first">
                注册需要进行验证码确认，请通过手机接收验证码
              </div>
              <div className="modal-second">
                <div className="title-text">当前账户安全手机:</div>
                <div className="phone-number">{delText}</div>
              </div>

              <div className="modal-third">
                <div className="first-code-number">
                  <InputField isDisabled={isVerifyLoading}>
                    <input
                      ref={codeNumFirstRef}
                      type="text"
                      value={firstCode}
                      onChange={(e) => {
                        setFirstCode(e.target.value);
                        setIsVerifyError(false);
                        if (e.target.value) {
                          codeNumSecondRef.current.focus();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value) {
                          codeNumSecondRef.current.focus();
                        }
                      }}
                      maxLength="1"
                      readOnly={isVerifyLoading}
                    />
                  </InputField>
                </div>
                <div className="second-code-number">
                  <InputField isDisabled={isVerifyLoading}>
                    <input
                      ref={codeNumSecondRef}
                      type="text"
                      value={secondCode}
                      onChange={(e) => {
                        setSecondCode(e.target.value);
                        setIsVerifyError(false);
                        if (e.target.value) {
                          codeNumThirdRef.current.focus();
                        } else {
                          codeNumFirstRef.current.focus();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value) {
                          codeNumThirdRef.current.focus();
                        } else {
                          codeNumFirstRef.current.focus();
                        }
                      }}
                      maxLength="1"
                      readOnly={isVerifyLoading}
                    />
                  </InputField>
                </div>
                <div className="third-code-number">
                  <InputField isDisabled={isVerifyLoading}>
                    <input
                      ref={codeNumThirdRef}
                      type="text"
                      value={thirdCode}
                      onChange={(e) => {
                        setThirdCode(e.target.value);
                        setIsVerifyError(false);
                        if (e.target.value) {
                          codeNumForthRef.current.focus();
                        } else {
                          codeNumSecondRef.current.focus();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value) {
                          codeNumForthRef.current.focus();
                        } else {
                          codeNumSecondRef.current.focus();
                        }
                      }}
                      maxLength="1"
                      readOnly={isVerifyLoading}
                    />
                  </InputField>
                </div>
                <div className="fourth-code-number">
                  <InputField isDisabled={isVerifyLoading}>
                    <input
                      ref={codeNumForthRef}
                      type="text"
                      value={forthCode}
                      onChange={(e) => {
                        setForthCode(e.target.value);
                        setIsVerifyError(false);
                        if (!e.target.value) {
                          codeNumThirdRef.current.focus();
                        }
                      }}
                      onInput={(e) => {
                        if (!e.target.value) {
                          codeNumThirdRef.current.focus();
                        }
                      }}
                      maxLength="1"
                      readOnly={isVerifyLoading}
                    />
                  </InputField>
                </div>
              </div>
              {isVerifyError && (
                <div className="cg-field-error">验证码错误</div>
              )}
            </div>
          </div>
        }
        title={"验证码确认"}
        onConfirm={() => getSecondCode()}
        okText={second < 1 ? "获取验证码" : `${second}秒后重新获取短信`}
        isConfirmLoading={isVerifyLoading || !(second < 1)}
      />

      <ModalConfirm
        isOpen={isMessageOpen}
        onClose={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        children={<div className="modal-body-text">{messageText}</div>}
        title={"操作确认"}
        onConfirm={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        okText="确认"
      />
    </div>
  );
};
export default Activation;
